<!--  -->
<template>
  <div class="content">
    <div class="ban" @click="tap(3)">
      <el-carousel trigger="click" :height="height + 'px'" style="z-index: ">
      <!-- <el-carousel-item>
          <img src="../../assets/ban1.jpg" alt="湖南生易圈教育咨询有限公司" />
          </el-carousel-item> -->
        <!-- <el-carousel-item>
          <img src="http://www.hitaledu.com/img/index.png" alt="湖南生易圈教育咨询有限公司" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="http://www.hitaledu.com/img/serve.png" alt="湖南生易圈教育咨询有限公司" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="http://www.hitaledu.com/img/forwarder.png" alt="湖南生易圈教育咨询有限公司" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="../../assets/ban.jpg" alt="湖南生易圈教育咨询有限公司" />
        </el-carousel-item>
        <el-carousel-item>
          <img src="http://www.hitaledu.com/img/personnel.png" alt="湖南生易圈教育咨询有限公司" />
        </el-carousel-item> -->
        <el-carousel-item v-for="(item,index) in list" :key="index" v-if="item.title=='首页'">
          <img :src="item.src1" alt="湖南生易圈教育咨询有限公司" />
        </el-carousel-item>
      </el-carousel>
      <!-- @click="url(item)" -->
    </div>
    <!-- 数字 -->
    <div class="number">
      <div class="card list">
        <div class="item" v-for="(item, index) in number" :key="index">
          <div class="top">
            <span class="number_text">
              <animate-number from="1" :to="item.number" duration="1000" :formatter="formatter"></animate-number>
            </span>
            <span class="number_day">{{ item.day }}</span>
          </div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 我们是做什么的？ -->
    <div class="do">
      <Link text="我们是做什么的？" />
      <div class="info card">
        <div class="img">
          <img :src="img_list[current].img" alt="湖南生易圈教育咨询有限公司" />
        </div>
        <div class="left">
          <div class="header">公司介绍</div>
          <div class="title">Introduction _</div>
          <div class="text">
            教育咨询服务是公司的延伸业务，公司结合国际供应链外贸综合服务及人才优势，立足外向型企业人才需求，成立湖南生易圈教育咨询有限公司，专注国际供应链领域的教育与咨询，致力打造政府、行业协会、园区、院校、企业五方联动的产教联盟平台机构。
            <br /><br />
            公司业务以产教融合为基础，通过五方联动，为各级政府的商务部门及园区提供产业发展研究及外向型经济人才解决方案；参与行业研究及标准建设；为院校提供从人才培养方案制定、实训室建设、实践教学、技能竞赛辅导、实习实训、创新创业及就业输送全流程服务；为成长型中小企业提供外贸相关技能培训、人才定制培养与输送、新业态（跨境电商、市场采购等）新项目孵化等，助力区域外向型经济高质量发展。
          </div>
        </div>
      </div>
      <!-- 切换卡片 -->
      <div class="wirth">
        <div class="left text">0{{ current + 1 }}/0{{ img_list.length }}</div>
        <div class="left">
          <!-- :class="current!=0?'newbgcolor':''" -->
          <div class="bgcolor" :class="current == 0 ? 'graybgcolor' : 'newbgcolor'" @click="jian">
            <span class="iconfont icon-angle-left ioc"></span>
          </div>

          <div class="bgcolor" :class="
            current == img_list.length - 1 ? 'graybgcolor' : 'newbgcolor'
          " @click="jia">
            <span class="iconfont icon-angle-right ioc"></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 海驼教育 -->
    <div class="Sea_camel">
      <div class="card flex">
        <div class="left">
          <div class="title">
            <div>
              <p class="hear_title">湖南生易圈教育咨询有限公司</p>
              <p class="hear_text">致力成为政、行、校、园、企五方联动的产教联盟服务平台。</p>
            </div>
            <div class="bg_img"><span>自我定位</span></div>
          </div>
          <div class="text">
            公司结合浩通外贸综合服务、国际贸易、国际物流、信息技术和人才等优势，
            专注国际供应链领域的教育与咨询，为企业和院校提供人才培养解决方案。
          </div>
        </div>
        <img src="../../assets/about/img.png" alt="湖南生易圈教育咨询有限公司" />
      </div>
    </div>
    <!-- 荣誉证书 -->
    <div class="honor card">
      <Link text="荣誉证书" />
      <div class="list">
        <div class="li" v-for="(item, index) in honer_img" :key="index">
          <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 我们的优势特点 -->
    <div class="pos">
      <div class="advantage">
        <Link text="我们的优势特点" />

        <div class="list card">
          <div class="li" v-for="(item, index) in pos_list" :key="index">
            <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
            <div>
              <div class="title">{{ item.title }}</div>
              <div class="text">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我们的战略合作伙伴 -->
    <div class="partner">
      <Link text="我们的战略合作伙伴" />
      <div class="list card">
        <div class="li" v-for="(item, index) in img_lists" :key="index">
          <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
        </div>
      </div>
    </div>

    <!-- 我们的优秀讲师 -->
  <!-- <div class="teacher">
      <div class="card">
        <Link text="我们的优秀讲师" one="1" />
        <div class="list lbt">
          <div class="li" v-for="(item, index) in tearch_list" :key="index">
              <img :src="item.img" alt="湖南生易圈教育咨询有限公司" />
              <div class="title">{{item.title}}</div>
              <div class="text">{{item.text}}</div>
            </div>
        </div>
      </div>
      </div> -->
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      list:[],//轮播图
      height: 700,
      number: [
        {
          number: 25,
          day: "年",
          text: "行业沉淀",
        },
        {
          number: 30,
          day: "+",
          text: "合作院校",
        },
        {
          number: 50000,
          day: "+",
          text: "培训人数",
        },
        {
          number: 500,
          day: "+",
          text: "培训场次",
        },
      ],
      img_list: [
        {
          img: require("../../assets/about/lbt1.png"),
        },
        {
          img: require("../../assets/about/lbt2.png"),
        },

      ],
      honer_img: [
        {
          img: require("../../assets/about/zs_01.png"),
          title: '中国物流学会产学研基地',
          text: '2020年',
        },
        {
          img: require("../../assets/about/zs_02.png"),
          title: '优秀产学研基地',
          text: '2021年',
        },
        {
          img: require("../../assets/about/zs_03.png"),
          title: '湖南培训中心',
          text: '中国货代协会',
        },
        {
          img: require("../../assets/about/zs_04.png"),
          title: '物流从业人员职业能力等级认证培训中心',
          text: '2019年',
        }
      ],
      pos_list: [
        {
          img: require("../../assets/index/ico1.png"),
          title: "多年的行业经验",
          text: "公司整合20多年来外贸行业的服务经验和客户资源，已形成完整的供应链领域的教育与咨询服务，可系统的、批量的为企业外贸相关人员提升实操技能。",
        },
        {
          img: require("../../assets/index/ico3.png"),
          title: "经验丰富的培训实战",
          text: "组织和承办过多次大型公开课，实施外贸巡回大讲堂近千场，定期组织实施外贸企业人才培训班、外贸储备人才培训班，培训外贸人才近万人。",
        },
        {
          img: require("../../assets/index/ico2.png"),
          title: "自主研发的实训教学软件",
          text: "我们整合院校对货代相关课程的企业实战需求，由公司IT团队、一线业务团队、学校授课老师三方共同探讨开发符合实际的实训教学软件。为高校提供实战教学平台。",
        },
      ],
      img_lists: [
        {
          img: require("../../assets/index/1.png"),
        },
        {
          img: require("../../assets/index/2.png"),
        },
        {
          img: require("../../assets/index/3.png"),
        },
        {
          img: require("../../assets/index/25.png"),
        },
        {
          img: require("../../assets/index/5.png"),
        },
        {
          img: require("../../assets/index/6.png"),
        },
        {
          img: require("../../assets/index/7.png"),
        },
        {
          img: require("../../assets/index/8.png"),
        },
        {
          img: require("../../assets/index/9.png"),
        },
        {
          img: require("../../assets/index/26.png"),
        },
        {
          img: require("../../assets/index/11.png"),
        },
        {
          img: require("../../assets/index/12.png"),
        },
        {
          img: require("../../assets/index/13.png"),
        },
        {
          img: require("../../assets/index/14.png"),
        },
        {
          img: require("../../assets/index/15.png"),
        },
        {
          img: require("../../assets/index/16.png"),
        },
        {
          img: require("../../assets/index/17.png"),
        },
        {
          img: require("../../assets/index/18.png"),
        },
        {
          img: require("../../assets/index/19.png"),
        },
        {
          img: require("../../assets/index/20.png"),
        },
        {
          img: require("../../assets/index/21.png"),
        },
        {
          img: require("../../assets/index/22.png"),
        },
        {
          img: require("../../assets/index/23.png"),
        },
        {
          img: require("../../assets/index/24.png"),
        },
      ],
      tearch_list: [
        {
          img: require("../../assets/about/po1.png"),
          title: '陈  盼',
          text: '国际物流实战讲师'
        },
        {
          img: require("../../assets/about/po2.png"),
          title: '沈万玲',
          text: '外贸全流程实战讲师'
        },
        {
          img: require("../../assets/about/po3.png"),
          title: '吴兢尧',
          text: '进出口通关实战讲师'
        },
        {
          img: require("../../assets/about/po4.png"),
          title: '龙群超',
          text: '加工贸易实战讲师'
        },
      ],
      current: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    url(item){
      if(item.banner_url!=''){
        window.open(item.banner_url)
      }
    },
    // 跳转
    tap(index) {
      this.$router.push('/Contact_us');
      localStorage.setItem("current", 3);
      this.$store.state.current = 3;
    },
    formatter: function (num) {
      return num.toFixed(0); //小数点后几位，数字就是几小数点后几位
    },
    // 左
    jian() {
      if (this.current > 0) {
        this.current--;
      }
    },
    // 右
    jia() {
      if (this.current < this.img_list.length - 1) {
        this.current++;
      }
    },
     // 加载
     openFullScreen2() {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
       
      },
    // 获取数据
    getData() {
      this.$http
        .get("http://www.hitaledu.com/admin/message/bannerListJson?page=1&limit=10")
        .then((response) => {
          if (response.data.code == 0) {
            this.list = response.data.data;
            this.loading.close();
          } else {
            this.$message({
              message: response.data.msg,
              type: "error",
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { 
    this. openFullScreen2();
    this.getData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (document.documentElement.clientWidth != 1920) {
      this.height = document.documentElement.clientWidth / (1920 / 700);
    }
    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth != 1920) {
          this.height = document.body.clientWidth / (1920 / 700);
        }
      })();
    };
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
@import url(../About/pc);
@import url(../About/mod);
</style>
